import { isObject as isObjectFunctionInToolkit } from "kwikid-toolkit";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isString = (x: string) => typeof x === "string";
  const { isArray } = Array;
  const isObject = (x: any) => isObjectFunctionInToolkit(x);

  const methods = {
    config: isObject,
    data: isArray,
    id: isString
  };

  return methods[key] && methods[key](value);
};
